import React, { memo } from 'react';

const RequiredLabel = ({label}) => {
  return (
    <>
      <span>{label}<span style={{color:'red'}}>*</span></span>
    </>
  )
}

export default memo(RequiredLabel);
